import type { RouteRecordRaw } from 'vue-router'
import { assertThat } from '../Guards'
import { Routes } from '../../Constants/Routes.ts'
import RedirectToLegacyPage from '../../Views/RedirectToLegacyPage.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/portefeuille',
    meta: {
      guards: assertThat().authenticated(),
    },
    children: [
      {
        name: Routes.WALLET_CONTRACT_VIEW,
        path: ':id(\\d+)',
        component: RedirectToLegacyPage,
        props: (route) => ({ id: Number(route.params.id) }),
        meta: {
          target: '/portefeuille/portefeuille.php?i={id}&p=detail',
        },
      },
    ],
  },
]

export default routes
